export enum GuidanceCardType {
  DO = 'DO',
  DONT = 'DONT',
}
